// Stanford's undergraduate majors (#2652, founder 2026-09-30: "majors offered
// by the college in the public page"). Read on 2026-10-01 from the official
// Stanford Bulletin 2026-27 (bulletin.stanford.edu/programs, catalog effective
// 2026-08-01): every program the Bulletin types as an undergraduate Major or
// Individually Designed Major, with its BA or BS. Minors, interdisciplinary
// honors, PhD minors and graduate degrees are left out. The Bulletin lists
// programs in one A to Z list without schools, so this is one group. The
// Engineering (BS) subplans (Architectural Design, Biomechanical Engineering
// and the rest) have their own Bulletin entries and are listed as the
// Bulletin names them. No official admission page read for this file states
// an extra requirement or limited entry for a major, so there are no flags.
// The KB's list (majors.stanford.edu) was the starting point; the Bulletin wins.
const majors = {
    "slug": "stanford-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Stanford's official Bulletin for 2026-27, with the degree it leads to. Minors, honors programs and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor's degree programs",
            "source": {
                "label": "Stanford Bulletin 2026-27, Programs",
                "url": "https://bulletin.stanford.edu/programs"
            },
            "majors": [
                {
                    "name": "Aeronautics and Astronautics",
                    "degree": "BS"
                },
                {
                    "name": "African and African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Archaeology",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art Practice",
                    "degree": "BA"
                },
                {
                    "name": "Asian American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chicana/o - Latina/o Studies",
                    "degree": "BA"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Studies in Race and Ethnicity",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Design",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Planetary Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Earth Systems",
                    "degree": "BS"
                },
                {
                    "name": "East Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Energy Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering: Architectural Design",
                    "degree": "BS"
                },
                {
                    "name": "Engineering: Atmosphere and Energy",
                    "degree": "BS"
                },
                {
                    "name": "Engineering: Biomechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering: Biomedical Computation",
                    "degree": "BS"
                },
                {
                    "name": "Engineering: Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Engineering: Sustainable Architecture and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Feminist, Gender, and Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geophysics",
                    "degree": "BS"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Biology",
                    "degree": "BA"
                },
                {
                    "name": "Human Biology",
                    "degree": "BS"
                },
                {
                    "name": "Iberian and Latin American Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Individually Designed Major in Engineering",
                    "degree": "BS"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Management Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Native American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy and Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Science, Technology, and Society",
                    "degree": "BA"
                },
                {
                    "name": "Science, Technology, and Society",
                    "degree": "BS"
                },
                {
                    "name": "Slavic Languages and Literatures",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Symbolic Systems",
                    "degree": "BS"
                },
                {
                    "name": "Theater and Performance Studies",
                    "degree": "BA"
                },
                {
                    "name": "Urban Studies",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
